import { Button, Table, Modal, Form, Space, Select, SelectProps, Alert, Tag, Skeleton, Spin, Radio, Input, Tabs } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Card, Col, Row } from 'react-bootstrap';
import { notify_success, toastStyle } from '../pages/UsersPage';
import { RequiredMark } from 'antd/es/form/Form';
import { CloseOutlined, EditFilled, FileExcelOutlined, InfoCircleOutlined, SaveOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { listFacts } from '../actions/factsActions';
import { selectUserDetails } from '../features/auth/authSlice';
import * as XLSX from 'xlsx';
import { API_URL, AUTH_URL, DATA_URL } from '../constants';
import { TfiReload } from 'react-icons/tfi';
import { notify } from '../pages/LoginPage';
import { IBranch } from './UsersTable';
import { DatePicker } from 'antd';
import moment, { Moment } from 'moment';
import dayjs, { Dayjs } from 'dayjs';
import { ILoan, ILoanDetails, ISaving } from '../factory/interfaces';
import TabPane from 'antd/es/tabs/TabPane';
import { PiAddressBookLight } from 'react-icons/pi';
import { MdWorkOutline } from 'react-icons/md';
import { IoIosPerson, IoMdArrowDropright } from 'react-icons/io';


const { RangePicker } = DatePicker

const SavingsTable = () => {
    const dispatch = useDispatch()

    //variable/states
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editable, setEditable] = useState(true);
    const [dateRange, setDateRange]= useState<string[]>(['2024-03-17', '2024-05-20'])
    const [selectedLoan, setSelectedLoan]= useState<string |undefined>()
    const [loanData, setLoanData]= useState<ILoanDetails>()
    const [loanLoaded, setLoanLoaded]= useState(false)
    const [editMode, setEditMode]= useState<boolean>(false)
    const momentArray: Moment[] = dateRange.map(date => moment(date))
    type EventValue<T> = T | null

  // Convert moment array to Dayjs array
  const dayjsArray: Dayjs[] = momentArray.map(date => dayjs(date.toDate()));
      const valueArray: [EventValue<Dayjs>, EventValue<Dayjs>] = [
    dayjsArray[0] || undefined,
    dayjsArray[1] || undefined,
  ];


   const user_details = useSelector(selectUserDetails)
  
    const [savings, setSavings] = useState<ISaving[]>()

    //Functions

    const handleRowClick = async (record: any) => {
       setSelectedLoan(record._id)
        const response = await axios.get(`${AUTH_URL}/finances/savings/${record._id}`)
        if(response.data.success){

            setLoanData(response.data.loan)
            setLoanLoaded(true)
            showModal()
        }
  }

 const columns = [
    {
    title: 'No.',
    dataIndex: 'count',
    render: (text:any, record:any, index:any) => index + 1,
  },
  {
    title: 'Client',
    dataIndex: 'client',
    key: 'client',
  },
   {
    title: 'Date',
    dataIndex: 'date_of_creation',
    key: 'date_of_creation',
  },
  {
    title: 'Amount saved',
    dataIndex: 'amount',
    key: 'amount',
  },

];

    //Components


  const clearUserData = ()=> setLoanData(undefined)
  const showModal = () => {
    setIsModalOpen(true);
  }

  const handleOk = () => {
    setIsModalOpen(false);
    clearUserData()
  };

  const handleCancel = () => {
    setIsModalOpen(false)
    clearUserData()
  }

  const getSavings = async()=>{
      const response = await axios.get(`${AUTH_URL}/finances/savings`, {withCredentials: true})
      if(response.data.success){
        setSavings(response.data.savings)
      }else{
        notify(`${response.data.message}`, toastStyle)
      }

    }

  useEffect(()=>{
    getSavings()

  }, [dispatch, dateRange])

  return (
    <>
    {savings? 
    <>

    <Row className=' justify-content-between align-items-center py-0 g-0'>
        <Col className='text-start py-2'>
         <h4 className='medium text-uppercase fw-bold' style={{color: '#052c65', fontSize: 16}}> <IoMdArrowDropright />Savings</h4>
        </Col>
         <Col className='text-end py-2'>
            <Button  className='rounded-0' type="dashed"> <TfiReload/> <span className='mx-1'>Reload</span></Button>
         </Col>
            
        </Row>
    
     {
      savings &&
      <Table className='rounded-0' id='savings-data-table' bordered dataSource={savings} columns={columns} 
       />

     }
     
      
      </> : 
        <Spin style={{paddingTop: 100}} tip="Loading data..." size="large">
        <div className="content" />
      </Spin>

    }

    {
      (loanData && loanLoaded) ?

      <>
      <Modal width={800} open={isModalOpen} onOk={handleOk} onCancel={handleCancel}
         title={`Loan Information`}
         centered
         footer={[
                    editMode 
                    ? [
                         <Button className='rounded-0' key="edit_mode_off" onClick={(e)=>setEditMode(false)}>
                           <span><CloseOutlined /> </span>Cancel Editing
                         </Button>,

                     ]
                    : 
                      [
                      <Button  className='rounded-0' key="cancel" onClick={handleCancel}>
                      <CloseOutlined />   Cancel
                      </Button>

                      ]
                ]}
         >
         <Card className='p-2 rounded-0'>
         <Tabs defaultActiveKey='1'>
          <TabPane
            tab={
              <span>
                <IoIosPerson style={{marginRight: "5px"}}/>
                Loan Details
              </span>
            }
            key="1"
          >
          <Form
                layout="vertical"
                    >
                    <Row>
                    <Col>
                    <Form.Item 
                    label="Amount" 
                    name="amount"
                    initialValue={loanData.amount}
                    >
                        <Input readOnly
                         />
                    </Form.Item>
                    
                    </Col>
                    <Col>
                       
                    <Form.Item label="Default Clause"
                    name="default_clause_amount"
                    initialValue={loanData.default_clause_amount}
                    >
                        <Input readOnly 
                        
                        />
                    </Form.Item>
                    
                    </Col>
                    
                    </Row>
                    <Row>
                    <Col>
                    <Form.Item label="Security type"
                    name="security_type"
                    initialValue={loanData.security_type}
                    >
                        <Input readOnly
                          
                        />
                    </Form.Item>
                    
                    </Col>
                    <Col>
                     <Form.Item label="Security"
                    name="security"
                    initialValue={loanData.security}
                    >
                        <Input readOnly
                        />
                    </Form.Item>
                    
                    </Col>
                    
                    </Row>
                    <Row>
                    <Col>
                    <Form.Item 
                      label="Start date"
                      name="loan_start_date"
                      initialValue={loanData.loan_start_date}

                      >
                        <Input readOnly
                         />
                    </Form.Item>
                    
                    </Col>
                    <Col>
                    <Form.Item 
                    label="End date"
                    name="phone"
                    initialValue={loanData.loan_end_date}

                    >
                      <Input readOnly
                         />
                    </Form.Item>
                    
                    </Col>
                    </Row>
                    <Row>
                      <Col>
                      <Form.Item 
                      label="Date of registration"
                      name="date_of_creation"
                      initialValue={loanData.date_of_creation}

                      >
                          <Input readOnly
                          />
                      </Form.Item>
                      
                      </Col>
                      <Col>              
                      </Col>
                    </Row>
                   

                </Form>
            
          </TabPane>
          <TabPane
            tab={
              <span>
                <MdWorkOutline style={{marginRight: "5px"}} />
                Guarantors Information
              </span>
            }
            key="2"
          >
          <Row>
          
          {
            loanData.guarantors.map((guarantor, index, array)=>{
              return <>
              <Col>
              
              <Form
                layout="vertical"
                    >
                    <Form.Item 
                    label={`Guarantor ${index +1} name`}
                    name={`guarantor_${index + 1}_name`}
                    initialValue={guarantor.name}
                    >
                        <Input readOnly
                         />
                    </Form.Item>
                    <Form.Item 
                      label={`Guarantor ${index +1} phone`}
                      name={`guarantor_${index + 1}_phone`}
                      initialValue={guarantor.phone}
                    >
                        <Input readOnly
                        />
                    </Form.Item>
                    <Form.Item 
                      label={`Guarantor ${index +1} address`}
                      name={`guarantor_${index + 1}_address`}
                    initialValue={guarantor.address}

                    >
                        <Input readOnly
                         />
                    </Form.Item>
                    {/* <Form.Item 
                      label="Employer address"
                      rules={[{required: true, message: "Phone number is required!"}]}
                      name="employer_address"
                      initialValue={loanData.employer?.address}

                      >
                        <Input disabled={!editMode}
                          onChange={(e) =>
                                setLoanData((prevUserData: any) => ({
                                    ...prevUserData,
                                    phone: e.target.value,
                                }))
                            }
                         />
                    </Form.Item> */}
                </Form>
                </Col>
              
              </>
            })
          }
          </Row>
          
            
          </TabPane>

          {/* Address Tab */}
          <TabPane
            tab={
              <span>
                <PiAddressBookLight style={{marginRight: "5px"}} />
                Client Details
              </span>
            }
            key="3"
          >
          <Form
                layout="vertical"
                    >
                    <Row>
                    <Col>
                    <Form.Item 
                    label={`Surname`}
                    name='surname'
                    initialValue={loanData.client.surname}
                    >
                        <Input readOnly
                         />
                    </Form.Item>
                    <Form.Item 
                    label={`Given name`}
                    name='given_name'
                    initialValue={loanData.client.given_name}
                    >
                        <Input readOnly
                         />
                    </Form.Item>
                    <Form.Item 
                    label={`ID number`}
                    name='id_number'
                    initialValue={loanData.client.id_number}
                    >
                        <Input readOnly
                         />
                    </Form.Item>
                    </Col>
                    <Col>
                    <Form.Item 
                    label={`Phone`}
                    name='phone'
                    initialValue={loanData.client.phone}
                    >
                        <Input readOnly
                         />
                    </Form.Item>
                    <Form.Item 
                    label={`Subcounty`}
                    name='sub_county'
                    initialValue={loanData.client.sub_county}
                    >
                        <Input readOnly
                         />
                    </Form.Item>
                    <Form.Item 
                    label={`Vilage`}
                    name='village'
                    initialValue={loanData.client.village}
                    >
                        <Input readOnly
                         />
                    </Form.Item>
                    
                    </Col>
                    
                    </Row>
                </Form>
            
          </TabPane>
         
         </Tabs>
         
                
            </Card>
      </Modal>
      </>
      :
      <>
      
      </>
    }
    </>
  )
}

export default SavingsTable